import { JiraRelease } from '@hefe/models';
import { formatDate } from '@hefe/utils';
import { Anchor, Col, Divider, Row, Space, Typography } from 'antd';
import { useMemo } from 'react';
import releaseNotesJson from '../../../../../release-notes.json';

export default function VersionsPage() {
  const releases = releaseNotesJson as unknown as JiraRelease[];

  const anchorItems = useMemo(() => {
    return releases.map((release) => {
      return {
        key: release.name,
        href: 'release_' + release.name,
        title: release.name,
      };
    });
  }, [releases]);

  const releaseItems = useMemo(() => {
    return releases.map((release) => {
      const anchorId = 'release_' + release.name;
      const issueKeys = Object.keys(release.issues);
      return (
        <div key={anchorId} id={anchorId}>
          <Space align="baseline">
            <Typography.Title level={2}>{release.name}</Typography.Title>
            {release.date && (
              <Typography.Text style={{ fontSize: 12 }}>
                {formatDate(release.date)}
              </Typography.Text>
            )}
          </Space>
          {issueKeys.map((issueKey) => {
            return (
              <div>
                <Typography.Title level={3}>{issueKey}</Typography.Title>
                <ul>
                  {release.issues[issueKey].map((issue) => {
                    return <li>{issue.summary}</li>;
                  })}
                </ul>
              </div>
            );
          })}
          <Divider />
        </div>
      );
    });
  }, [releases]);

  return (
    <Row>
      <Col span={8}>
        <Anchor
          offsetTop={30}
          onClick={(e, link) => {
            e.preventDefault();
            document.getElementById(link.href)?.scrollIntoView();
          }}
          items={anchorItems}
        />
      </Col>
      <Col span={16}>{releaseItems}</Col>
    </Row>
  );
}
